import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import "./VendorForm.css";
import ReusableSelect from "../../../components/ReusableSelect/ReusableSelect";
import { userlocationData } from "../../../Data/data";
import { useNavigate } from "react-router-dom";
import { vendorValidationSchema } from "../../../Validations/Validations";
import DiscardChangesDialog from "../../../components/DiscardChangesDialog/DiscardChangesDialog";
import { useDispatch, useSelector } from "react-redux";
import functions from "../../../utils/Api";
import Toaster from "../../../components/Toaster/Toaster";
import { Switch } from "@mui/material";
import UsertypeDropdown from "../../../components/UsertypeDropdown/UsertypeDropdown";
import { setUserType } from "../../../Redux/persistApiDataSlice";

const VendorForm = ({
  title,
  vendorDetails,
  setVendorDetails,
  handleVendorSubmit,
  disableCreateBtn,
}) => {
  let navigate = useNavigate();
  const dispatcher = useDispatch();
  // const locationData = useSelector(
  //   (state) => state.mealAppReducer.locationsList
  // );
  const locationData = useSelector(
    (state) => state.persistApiData.locationsList
  );
  const userTypeData = useSelector(
    (state) => state.persistApiData.userTypeData
  );
  const userType = useSelector((state) => state.persistApiData.userType);

  const [discardChangesDialogStatus, setDiscardChangesDialogStatus] =
    useState(false);

  const handleRedirect = () => {
    let hasChanges = Object.values(vendorDetails).some(
      (value) => value.length > 1
    );
    if (hasChanges) {
      setDiscardChangesDialogStatus(true);
    } else {
      setDiscardChangesDialogStatus(false);
      dispatcher(setUserType(null));
      navigate("/cms/users-list");
    }
  };

  const handleUserDetails = (event, setFieldValue) => {
    setVendorDetails({
      ...vendorDetails,
      [event.target.name]: event.target.value,
    });
    setFieldValue(event.target.name, event.target.value);
  };

  const handleSubmit = () => {
    handleVendorSubmit();
  };

  const handleCancel = () => {
    dispatcher(setUserType(null));
    navigate("/cms/users-list");
  };

  const handleCreate = () => {
    setDiscardChangesDialogStatus(false);
    navigate("/cms/users-list");
  };

  const handleActive = (event) => {
    setVendorDetails({
      ...vendorDetails,
      isActive: event.target.checked ? true : false,
    });
  };

  const handleRedirectUser = (e) => {
    dispatcher(setUserType(e.target.value));
    handleRouting(e.target.value);
  };

  const handleRouting = (value) => {
    if (title === "Add") {
      if ([1, 3].includes(value)) {
        navigate("/cms/add-user");
      }
      if (value === 2) {
        navigate("/cms/add-vendor");
      }
    }
  };

  return (
    <div>
      <Formik
        initialValues={vendorDetails}
        enableReinitialize={true}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={vendorValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, values, setFieldValue, setFieldTouched }) => (
          <Form>
            <Box className="vendor">
              <Card className="vendor-Body">
                <CardContent>
                  <Box className="vendor-titleMain">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        aria-label="delete"
                        size="medium"
                        className="vendor-titleMain-iconBtn"
                        onClick={handleRedirect}
                        sx={{
                          "&:hover": {
                            backgroundColor: "#004D72",
                            color: "#FFFFFF",
                          },
                        }}
                      >
                        <ArrowBackIosNewOutlinedIcon
                          fontSize="inherit"
                          sx={{
                            width: "15px",
                          }}
                        />
                      </IconButton>
                      <Typography
                        variant="h6"
                        className="vendor-titleMain-label"
                      >
                        <b>{title} Vendor</b>
                      </Typography>
                    </Box>
                    {title === "Update" && (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{
                            color: "#464B4F",
                            fontWeight: "400",
                            marginRight: "10px",
                          }}
                        >
                          Status :
                        </Typography>
                        <Typography
                          sx={{ color: "#000000", fontWeight: "600" }}
                        >
                          Active
                        </Typography>
                        <Typography>
                          <Switch
                            color="success"
                            value={vendorDetails.isActive}
                            checked={vendorDetails.isActive ? true : false}
                            onChange={handleActive}
                          />
                        </Typography>
                        <Typography
                          sx={{ color: "#000000", fontWeight: "600" }}
                        >
                          InActive
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Divider />
                  <Grid container spacing={4} className="vendor-fields">
                    <Grid item xs={4}>
                      <UsertypeDropdown
                        title={title}
                        value={userType}
                        data={userTypeData}
                        handleChange={handleRedirectUser}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={4}>
                        <Grid item xs={4}>
                          <Field
                            label="Vendor Name"
                            fullWidth
                            as={TextField}
                            placeholder="Enter Vendor Name"
                            value={values.vendorName}
                            name="vendorName"
                            onChange={(event) =>
                              handleUserDetails(event, setFieldValue)
                            }
                            size="small"
                            error={
                              touched.vendorName && Boolean(errors.vendorName)
                            }
                            helperText={<ErrorMessage name="vendorName" />}
                            onKeyPress={(e) => {
                              const regex = /^[a-zA-Z\s]+$/; // Allow letters and spaces only
                              if (!regex.test(e.key)) {
                                e.preventDefault(); // Block invalid input
                              }
                            }}
                            inputProps={{
                              maxLength: 50,
                            }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <FormControl
                            fullWidth
                            error={
                              touched.vendorLocationId &&
                              Boolean(errors.vendorLocationId)
                            }
                            size="small"
                          >
                            <InputLabel id="VendorlocationType-label">
                              Select Location
                            </InputLabel>
                            <Select
                              labelId="VendorlocationType-label"
                              id="Vendorlocation"
                              name="vendorLocationId"
                              value={values.vendorLocationId}
                              onChange={(event) =>
                                handleUserDetails(event, setFieldValue)
                              }
                              onBlur={() =>
                                setFieldTouched("vendorLocationId", true)
                              }
                              label="Select Location"
                            >
                              {locationData.length > 0 &&
                                locationData.map((item, i) => (
                                  <MenuItem key={i} value={item.locationId}>
                                    {item.displayName}
                                  </MenuItem>
                                ))}
                            </Select>
                            {touched.vendorLocationId &&
                              errors.vendorLocationId && (
                                <Typography
                                  variant="body2"
                                  color="error"
                                  sx={{
                                    fontSize: "0.75rem",
                                    marginTop: "4px",
                                    marginLeft: "10px",
                                    color: "#d32f2f",
                                    fontFamily: "Lato, sans-serif",
                                  }}
                                >
                                  {errors.vendorLocationId}
                                </Typography>
                              )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}>
                          <Field
                            fullWidth
                            as={TextField}
                            placeholder="Enter Email Address"
                            value={values.vendorEmail}
                            name="vendorEmail"
                            onChange={(event) =>
                              handleUserDetails(event, setFieldValue)
                            }
                            label="Email Address"
                            size="small"
                            error={
                              touched.vendorEmail && Boolean(errors.vendorEmail)
                            }
                            helperText={<ErrorMessage name="vendorEmail" />}
                          />
                        </Grid>
                        <Grid item xs={4} className="vendor-phoneNumField">
                          <Field
                            label="Phone Number"
                            fullWidth
                            as={TextField}
                            maxLength={10}
                            placeholder="Enter Phone Num"
                            value={values.vendorPhone}
                            name="vendorPhone"
                            onChange={(event) =>
                              handleUserDetails(event, setFieldValue)
                            }
                            onKeyPress={(e) => {
                              // Prevent non-numeric characters
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onInput={(e) => {
                              // Limit to 10 digits
                              if (e.target.value.length > 10) {
                                e.target.value = e.target.value.slice(0, 10);
                              }
                            }}
                            size="small"
                            error={
                              touched.vendorPhone && Boolean(errors.vendorPhone)
                            }
                            helperText={<ErrorMessage name="vendorPhone" />}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>
            <Box className="vendor-BtnMain">
              <Button
                variant="outlined"
                className="vendor-CancleBtn"
                onClick={handleCancel}
                sx={{ padding: "7px 24px" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="vendor-createBtn"
                type="submit"
                disabled={disableCreateBtn}
                sx={{ padding: "7px 24px" }}
              >
                {title}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
      <DiscardChangesDialog
        title="Unsaved Changes"
        text=" If you go back now, any information you've entered will be lost.
        Are you sure you want to leave without saving?"
        createBtn=" Yes, Go Back"
        open={discardChangesDialogStatus}
        handleClose={setDiscardChangesDialogStatus}
        handleCreate={handleCreate}
      />
    </div>
  );
};

export default VendorForm;
